// src/utils/usernameGenerator.js

export function generateUsername() {
  // Large list of music-related adjectives
  const adjectives = [
    // Colors
    "Blue",
    "Red",
    "Golden",
    "Silver",
    "Crimson",
    "Emerald",
    "Azure",
    "Amber",
    // Emotions/Qualities
    "Happy",
    "Mellow",
    "Bright",
    "Smooth",
    "Wild",
    "Calm",
    "Funky",
    "Groovy",
    "Jazzy",
    "Soulful",
    "Epic",
    "Mellow",
    "Bold",
    "Dreamy",
    "Vibrant",
    "Lively",
    "Melodic",
    "Harmonic",
    "Rhythmic",
    "Electric",
    "Acoustic",
    "Digital",
    "Analog",
    // Performance-related
    "Swift",
    "Steady",
    "Fluid",
    "Dynamic",
    "Flowing",
    "Soaring",
    "Rising",
    "Resonant",
    "Echoing",
    "Virtuoso",
    "Majestic",
    "Grand",
    "Precise",
    "Intense",
    "Gentle",
    // Music-specific
    "Major",
    "Minor",
    "Chromatic",
    "Tonal",
    "Modal",
    "Pentatonic",
    "Diminished",
    "Augmented",
    "Syncopated",
    "Pizzicato",
    "Staccato",
    "Legato",
    "Vibrato",
  ];

  // Large list of music-related nouns
  const nouns = [
    // Instruments
    "Piano",
    "Guitar",
    "Drum",
    "Bass",
    "Violin",
    "Trumpet",
    "Flute",
    "Harp",
    "Clarinet",
    "Sax",
    "Cello",
    "Viola",
    "Oboe",
    "Tuba",
    "Horn",
    "Banjo",
    "Ukulele",
    // Musical elements
    "Note",
    "Chord",
    "Beat",
    "Rhythm",
    "Melody",
    "Harmony",
    "Song",
    "Tune",
    "Symphony",
    "Sonata",
    "Concerto",
    "Aria",
    "Solo",
    "Duet",
    "Quartet",
    "Ensemble",
    "Scale",
    "Octave",
    "Cadence",
    "Riff",
    "Lick",
    "Loop",
    "Track",
    "Mix",
    "Sample",
    // People in music
    "Maestro",
    "Artist",
    "Player",
    "Singer",
    "Composer",
    "Conductor",
    "Performer",
    "Soloist",
    "Musician",
    "Producer",
    "DJ",
    "Vocalist",
    "Instrumentalist",
    // Genres
    "Jazz",
    "Rock",
    "Pop",
    "Blues",
    "Folk",
    "Classical",
    "Opera",
    "Indie",
    "Metal",
    "Funk",
    "Soul",
    "R&B",
    "Disco",
    "Techno",
    "House",
    "Hip-Hop",
    "Reggae",
    "Country",
  ];

  // Random elements to ensure uniqueness
  const randomNum = Math.floor(Math.random() * 1000);

  // Pick random adjective and noun
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];

  // Create username with random number for uniqueness
  return `${adjective}${noun}${randomNum}`;
} 